












import Vue from 'vue';
import Component from 'vue-class-component';
import { Chart } from 'highcharts-vue';
import db from '@/PedalparadeDB.json';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class Stats extends Vue {
  private pedalsTotal: number = db.pedals.length;
  private pedalsTotalCounter: number = 0;
  private publishedPedals: any[] = db.pedals.filter((pedal: any) => pedal.publish);

  get pedalsByType() {
    const pedalsByType = [];
    const publishedPedalTypes = this.publishedPedals.map((pedal: any) => pedal.type);
    const pedalTypeCounts = publishedPedalTypes.reduce((acum: any, cur: any) => Object.assign(acum, {[cur]: (acum[cur] | 0)+1}), {}); // tslint:disable-line

    for (const pedalTypeCount in pedalTypeCounts) {
      if (pedalTypeCounts[pedalTypeCount]) {
        pedalsByType.push({
          name: pedalTypeCount,
          y: pedalTypeCounts[pedalTypeCount],
        });
      }
    }

    const pedalsByTypeOptions = {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
      },
      colors: [
        '#f44336', '#607d8b', '#e91e63', '#9e9e9e', '#9c27b0', '#795548', '#ff5722', '#673ab7', '#ff9800',
        '#3f51b5', '#ffc107', '#2196f3', '#ffeb3b', '#03a9f4', '#cddc39', '#00bcd4', '#8bc34a', '#009688',
        '#4caf50',
      ],
      exporting: {
        enabled: false,
      },
      title: {
        margin: 0,
        style: {
          color: '#0c2032',
          fontFamily: '"skolar-latin", serif',
          fontSize: '25px',
          fontWeight: 100,
          lineHeight: '30px',
          textTransform: 'uppercase',
        },
        text: 'Pedals by type',
      },
      tooltip: {
        backgroundColor: '#fff',
        borderRadius: 1.6,
        headerFormat: '',
        pointFormat: '{point.name} <b>{point.y}</b>',
        style: {
          borderRadius: 1.6,
          color: '#0c2032',
          fontFamily: '"skolar-latin", serif',
          fontSize: 16,
          fontWeight: 100,
        },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          borderColor: null,
          borderWidth: 0.5,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '{point.name} {point.percentage:.1f}%',
            style: {
              color: '#0c2032',
              fontFamily: '"skolar-latin", serif',
              fontSize: '13px',
              fontWeight: 100,
              textOutline: 'none',
            },
          },
        },
      },
      credits: {
          enabled: false,
      },
      series: [{
        data: pedalsByType,
      }],
      responsive: {
        rules: [{
          condition: {
            minWidth: 720,
          },
          chartOptions: {
            title: {
              style: {
                fontSize: '31px',
                lineHeight: '37px',
              },
            },
            plotOptions: {
              pie: {
                dataLabels: {
                  style: {
                    fontSize: '20px',
                  },
                },
              },
            },
          },
        }],
      },
    };

    return pedalsByTypeOptions;
  }

  get pedalsByBrand() {
    const pedalsByBrand = [];
    const publishedPedalBrands = this.publishedPedals.map((pedal: any) => pedal.brand);
    const pedalBrandCounts = publishedPedalBrands.reduce((acum: any, cur: any) => Object.assign(acum, {[cur]: (acum[cur] | 0) + 1}), {}); // tslint:disable-line

    for (const pedalBrandCount in pedalBrandCounts) {
      if (pedalBrandCounts[pedalBrandCount]) {
        pedalsByBrand.push({
          name: pedalBrandCount,
          y: pedalBrandCounts[pedalBrandCount],
        });
      }
    }

    pedalsByBrand.sort((a, b) => (a.y > b.y) ? 1 : (a.y === b.y) ? ((a.name > b.name) ? 1 : -1) : -1);

    const pedalsByBrandOptions = {
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
      },
      exporting: {
        enabled: false,
      },
      title: {
        style: {
          color: '#0c2032',
          fontFamily: '"skolar-latin", serif',
          fontSize: '25px',
          fontWeight: 100,
          lineHeight: '30px',
          textTransform: 'uppercase',
        },
        text: 'Pedals by brand',
      },
      xAxis: {
        type: 'category',
        lineColor: '#0c2032',
        labels: {
            style: {
              color: '#0c2032',
              fontFamily: '"skolar-latin", serif',
              fontSize: '13px',
              fontWeight: 100,
            },
        },
        tickLength: 0,
      },
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          enabled: false,
        },
        plotLines: null,
        gridLineWidth: 0,
      },
      tooltip: {
          backgroundColor: '#fff',
          headerFormat: '',
          pointFormat: '{point.name} <b>{point.y}</b>',
          style: {
            borderRadius: 1.6,
            color: '#0c2032',
            fontFamily: '"skolar-latin", sans',
            fontSize: '16px',
            fontWeight: 100,
          },
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          colorByPoint: true,
          colors: [
            '#ff8a80', '#f44336', '#ff80ab', '#e91e63', '#ea80fc', '#9c27b0', '#b388ff', '#673ab7',
            '#8c9eff', '#3f51b5', '#82b1ff', '#2196f3', '#80d8ff', '#03a9f4', '#84ffff', '#00bcd4',
            '#a7ffeb', '#009688', '#b9f6ca', '#4caf50', '#ccff90', '#8bc34a', '#f4ff81', '#cddc39',
            '#ffff8d', '#ffeb3b', '#ffe57f', '#ffc107', '#ffd180', '#ff9800', '#ff9e80', '#ff5722',
            '#795548', '#3e2723', '#9e9e9e', '#212121', '#607d8b', '#263238',
          ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '16px',
            },
          },
        },
      },
      legend: {
          enabled: false,
      },
      credits: {
          enabled: false,
      },
      series: [{
        data: pedalsByBrand,
      }],
      responsive: {
        rules: [{
          condition: {
            minWidth: 720,
          },
          chartOptions: {
            title: {
              style: {
                fontSize: '31px',
                lineHeight: '37px',
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: '20px',
                },
              },
            },
          },
        }],
      },
    };

    return pedalsByBrandOptions;
  }

  get pedalsByCountry() {
    const pedalsByCountry: any[] = [];
    const countryIcons = [
      {
        country: 'Australia',
        icon: '🇦🇺',
      },
      {
        country: 'Brazil',
        icon: '🇧🇷',
      },
      {
        country: 'China',
        icon: '🇨🇳',
      },
      {
        country: 'Croatia',
        icon: '🇭🇷',
      },
      {
        country: 'Finland',
        icon: '🇫🇮',
      },
      {
        country: 'France',
        icon: '🇫🇷',
      },
      {
        country: 'Japan',
        icon: '🇯🇵',
      },
      {
        country: 'New Zealand',
        icon: '🇳🇿',
      },
      {
        country: 'Poland',
        icon: '🇵🇱',
      },
      {
        country: 'Sri Lanka',
        icon: '🇱🇰',
      },
      {
        country: 'Taiwan',
        icon: '🇹🇼',
      },
      {
        country: 'UK',
        icon: '🇬🇧',
      },
      {
        country: 'USA',
        icon: '🇺🇸',
      },
    ];
    const publishedPedalCountries = this.publishedPedals.map((pedal: any) => pedal.madeIn);
    const pedalCountryCounts = publishedPedalCountries.reduce((acum: any, cur: any) => Object.assign(acum, {[cur]: (acum[cur] | 0) + 1}), {}); // tslint:disable-line

    for (const countryCount in pedalCountryCounts) {
      if (pedalCountryCounts[countryCount]) {
        pedalsByCountry.push({
          name: countryCount,
          y: pedalCountryCounts[countryCount],
        });
      }
    }

    pedalsByCountry.sort((a, b) => (a.y < b.y) ? 1 : (a.y === b.y) ? ((a.name > b.name) ? 1 : -1) : -1);

    for (const pedalCountry of pedalsByCountry) {
      const countryIcon = countryIcons.find((country) => country.country === pedalCountry.name)!.icon;
      pedalCountry.name = pedalCountry.name + ' ' + countryIcon;
    }

    const pedalsByCountryOptions = {
      chart: {
        type: 'bar',
        backgroundColor: 'transparent',
      },
      exporting: {
        enabled: false,
      },
      title: {
        style: {
          color: '#0c2032',
          fontFamily: '"skolar-latin", serif',
          fontSize: '25px',
          fontWeight: 100,
          lineHeight: '30px',
          textTransform: 'uppercase',
        },
        text: 'Pedals by country',
      },
      xAxis: {
        type: 'category',
        lineColor: '#0c2032',
        labels: {
            style: {
              color: '#0c2032',
              fontFamily: '"skolar-latin", serif',
              fontSize: '13px',
              fontWeight: 100,
            },
        },
        tickLength: 0,
      },
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          enabled: false,
        },
        plotLines: null,
        gridLineWidth: 0,
      },
      tooltip: {
          useHTML: true,
          backgroundColor: '#fff',
          headerFormat: '',
          pointFormat: '{point.name} <b>{point.y}</b>',
          style: {
            borderRadius: 1.6,
            color: '#0c2032',
            fontFamily: '"skolar-latin", sans',
            fontSize: '16px',
            fontWeight: 100,
          },
      },
      plotOptions: {
        bar: {
          borderWidth: 0,
          colorByPoint: true,
          colors: [
            '#ff8a80', '#f44336', '#ff80ab', '#e91e63', '#ea80fc', '#9c27b0', '#b388ff', '#673ab7',
            '#8c9eff', '#3f51b5', '#82b1ff', '#2196f3', '#80d8ff', '#03a9f4', '#84ffff', '#00bcd4',
            '#a7ffeb', '#009688', '#b9f6ca', '#4caf50', '#ccff90', '#8bc34a', '#f4ff81', '#cddc39',
            '#ffff8d', '#ffeb3b', '#ffe57f', '#ffc107', '#ffd180', '#ff9800', '#ff9e80', '#ff5722',
            '#795548', '#3e2723', '#9e9e9e', '#212121', '#607d8b', '#263238',
          ],
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '16px',
            },
          },
        },
      },
      legend: {
          enabled: false,
      },
      credits: {
          enabled: false,
      },
      series: [{
        data: pedalsByCountry,
      }],
      responsive: {
        rules: [{
          condition: {
            minWidth: 720,
          },
          chartOptions: {
            title: {
              style: {
                fontSize: '31px',
                lineHeight: '37px',
              },
            },
            xAxis: {
              labels: {
                style: {
                  fontSize: '20px',
                },
              },
            },
          },
        }],
      },
    };

    return pedalsByCountryOptions;
  }

  private mounted() {
    const counter = setInterval(() => {
        this.pedalsTotalCounter += 1;
        if (this.pedalsTotalCounter === this.pedalsTotal || !this.pedalsTotal) {
          clearInterval(counter);
        }
      }, 100);
  }
}
